import { Box, BoxProps, Container, Flex } from "@chakra-ui/react";
import { SIDEBAR_WIDTH } from "definitions/constants/styling";
import Navbar from "layouts/Navbar";
import Sidebar from "layouts/Sidebar/Sidebar";
import AppPageSkeleton from "components/AppPageSkeleton";
import { Suspense } from "react";
import MissingMessageServiceBanner from "features/Issues/Components/GlobalIssuesBanner/MissingMessageServiceBanner";
import { MissingChannelMembershipBanner } from "features/Issues/Components/GlobalIssuesBanner/GlobalIssuesBanner";
import UnauthorizedMessageSenderBanner from "features/Issues/Components/GlobalIssuesBanner/UnauthorizedMessageSenderBanner";

type AppPageProps = BoxProps;

export default function AppPage({ children = undefined, ...rest }: AppPageProps) {
  return (
    <Suspense fallback={<AppPageSkeleton />}>
      <UnauthorizedMessageSenderBanner />
      <MissingMessageServiceBanner />
      <MissingChannelMembershipBanner />
      <Box minH="100vh" maxW="100vw" position="relative">
        <Flex height="100vh" id="app-container">
          <Box w={`var(--chakra-sizes-${SIDEBAR_WIDTH})`} fontSize="sm" height="100vh">
            <Sidebar />
          </Box>
          <Container
            height="100vh"
            overflowY="scroll"
            // max width is 100% minus the size of the sidebar
            maxWidth={`calc(100% - var(--chakra-sizes-${SIDEBAR_WIDTH}))`}
            bg="bg.primary"
            flex="1"
            display="flex"
            flexDirection="column"
            px="0"
            py="4"
          >
            <Navbar />
            <Box px="6" height="100%" maxWidth="full" {...rest}>
              {children}
            </Box>
          </Container>
        </Flex>
      </Box>
    </Suspense>
  );
}
